var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "swiper-slide swiper-slide-height",
      class: { "initial-swiper-slide": _vm.isInitialSwiperSlide },
      attrs: { tabindex: "0" },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }